import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

function Name() {
  const { projectId, nameId } = useParams();
  const [loading, setLoading] = useState(false);
  const [nameData, setNameData] = useState(null);
  const host = process.env.REACT_APP_SERVER;

  // Define a mapping from nameData values to numbers
  const nameDataMapping = {
    A: 100, // Map "A" to 80
    B: 80, // Map "B" to 60
    C: 60, // Map "C" to 40
    D: 40, // Map "D" to 20
    F: 0, // Map "F" to 0
    "": null, // Map "" (empty) to 0
  };

  useEffect(() => {
    setLoading(true);
    const fetchNameData = async () => {
      try {
        const response = await fetch(`${host}/api/projects/${projectId}/names/${nameId}`);
        const jsonData = await response.json();
        console.log(jsonData);
        setNameData(jsonData.data.name);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchNameData();
  }, [projectId, nameId]);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!nameData) {
    return <p>Name not found.</p>;
  }

  return (
    <div className="container mx-auto w-full pl-5">
      <div className="text-sm breadcrumbs pb-5">
        <ul>
          <li>
            <Link to={`/`} className="text-blue-500">
              <a>Home</a>
            </Link>
          </li>
          <li>
            <Link to={`/projects`} className="text-blue-500">
              <a>Projects</a>
            </Link>
          </li>
          <li>
            <Link to={`/projects/${nameData.project_id}`} className="text-blue-500">
              <a>{nameData.project_id}</a>
            </Link>
          </li>
          <li>
            <Link to={`/projects/${projectId}/names/${nameData.id}`} className="text-blue-500">
              <a>{nameData.name}</a>
            </Link>
          </li>
        </ul>
      </div>
      <div className="flex flex-col gap-5 w-full">
        <article className="prose ">
          <h1 className="text-2xl font-semibold">{nameData.name}</h1>
          <blockquote className="italic border-l-4 border-pink-500 pl-4 py-2 mb-4">
            <p>{nameData.definition}</p>
          </blockquote>
        </article>
        <ul className="steps">
          <li className="step step-primary">
            <h3>Model:</h3>
            <Link to={`/models/${nameData.model}`}>
              <p className="text-blue-500">{nameData.model}</p>
            </Link>
            {nameData.source ? (
              <a href={nameData.source} target="_blank" rel="noopener noreferrer">
                Link
              </a>
            ) : (
              <></>
            )}
          </li>
          {nameData.original ? (
            <li className="step step-primary">
              <h3>Original:</h3>
              {/* <Link to={`/projects/${nameData.original}`}> */}
              <p className="text-blue-500">{nameData.original}</p>
              {/* </Link> */}
            </li>
          ) : (
            <></>
          )}
          {nameData.mutations.length > 0 ? (
            nameData.mutations.map((d) => (
              <li className="step step-primary">
                <h3>Mutation:</h3>
                <Link to={`/mutations/${d}`}>
                  <p className="text-blue-500">{d}</p>
                </Link>{" "}
              </li>
            ))
          ) : (
            <></>
          )}
          <li className="step step-primary">
            <h3>Name:</h3>
            {/* <Link to={`/models/${nameData.model}`}> */}
            <p className="text-blue-500">{nameData.name}</p>
            {/* </Link> */}
          </li>
        </ul>
        <p>{nameData.description}</p>

        {nameData.trademark ? (
          <span>
            <progress className="progress progress-primary w-56 pr-5" value={nameDataMapping[nameData.trademark]} max="100"></progress>
            Trademark
          </span>
        ) : (
          <></>
        )}
        {nameData.uniqueness ? (
          <span>
            <progress className="progress progress-primary w-56 pr-5" value={nameDataMapping[nameData.uniqueness]} max="100"></progress>
            Uniqueness
          </span>
        ) : (
          <></>
        )}
        {nameData.pronounceability ? (
          <span>
            <progress className="progress progress-primary w-56 pr-5" value={nameDataMapping[nameData.pronounceability]} max="100"></progress>
            Pronounceability
          </span>
        ) : (
          <></>
        )}
        {nameData.evocativeness ? (
          <span>
            <progress className="progress progress-primary w-56 pr-5" value={nameDataMapping[nameData.evocativeness]} max="100"></progress>
            Evocativeness
          </span>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default Name;
